import React from "react";

export const detectCardType = (number) => {
  const cleanNumber = number.replace(/\s/g, "");

  if (/^4/.test(cleanNumber)) return "visa";
  if (/^5[1-5]/.test(cleanNumber) || /^2[2-7]/.test(cleanNumber))
    return "mastercard";
  if (/^3[47]/.test(cleanNumber)) return "amex";
  if (/^6(?:011|5)/.test(cleanNumber)) return "discover";

  return "unknown";
};

export const formatCardNumber = (value) => {
  const v = value.replace(/\s+/g, "").replace(/[^0-9]/gi, "");
  const matches = v.match(/\d{4,16}/g);
  const match = (matches && matches[0]) || "";
  const parts = [];

  for (let i = 0, len = match.length; i < len; i += 4) {
    parts.push(match.substring(i, i + 4));
  }

  if (parts.length) {
    return parts.join(" ");
  } else {
    return v;
  }
};

export const formatExpiryDate = (value) => {
  const v = value.replace(/\s+/g, "").replace(/[^0-9]/gi, "");

  if (v.length >= 2) {
    return `${v.substring(0, 2)}/${v.substring(2, 4)}`;
  }

  return v;
};

export const validateCardNumber = (number) => {
  const cleanNumber = number.replace(/\s/g, "");

  if (!/^\d+$/.test(cleanNumber)) return false;
  if (cleanNumber.length < 13 || cleanNumber.length > 19) return false;

  // Luhn algorithm
  let sum = 0;
  let isEven = false;

  for (let i = cleanNumber.length - 1; i >= 0; i--) {
    let digit = parseInt(cleanNumber.charAt(i), 10);

    if (isEven) {
      digit *= 2;
      if (digit > 9) {
        digit -= 9;
      }
    }

    sum += digit;
    isEven = !isEven;
  }

  return sum % 10 === 0;
};

export const validateExpiryDate = (expiry) => {
  if (!/^\d{2}\/\d{2}$/.test(expiry)) return false;

  const [month, year] = expiry.split("/").map((num) => parseInt(num, 10));

  if (month < 1 || month > 12) return false;

  const currentDate = new Date();
  const currentYear = currentDate.getFullYear() % 100;
  const currentMonth = currentDate.getMonth() + 1;

  if (year < currentYear || (year === currentYear && month < currentMonth)) {
    return false;
  }

  return true;
};

export const validateCVV = (cvv, cardType) => {
  const expectedLength = cardType === "amex" ? 4 : 3;
  return /^\d+$/.test(cvv) && cvv.length === expectedLength;
};

export const getCardIcon = (cardType) => {
  const iconClass = "w-8 h-6 rounded";

  switch (cardType) {
    case "visa":
      return (
        <div
          className={`${iconClass} bg-blue-600 flex items-center justify-center`}
        >
          <span className="text-white text-xs font-bold">VISA</span>
        </div>
      );
    case "mastercard":
      return (
        <div
          className={`${iconClass} bg-red-600 flex items-center justify-center relative overflow-hidden`}
        >
          <div className="w-3 h-3 bg-red-500 rounded-full absolute left-1"></div>
          <div className="w-3 h-3 bg-yellow-500 rounded-full absolute right-1"></div>
        </div>
      );
    case "amex":
      return (
        <div
          className={`${iconClass} bg-green-600 flex items-center justify-center`}
        >
          <span className="text-white text-xs font-bold">AMEX</span>
        </div>
      );
    case "discover":
      return (
        <div
          className={`${iconClass} bg-orange-600 flex items-center justify-center`}
        >
          <span className="text-white text-xs font-bold">DISC</span>
        </div>
      );
    default:
      return (
        <div
          className={`${iconClass} bg-gray-400 flex items-center justify-center`}
        >
          <span className="text-white text-xs font-bold">CARD</span>
        </div>
      );
  }
};
